module.exports = require("./nl-AW.d.ts");